module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAIAAAAIbfoLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAxElEQVR42q2TUQ0EIQxEKwEJSFgJSEACEpCAg5WABCQgAQlIQMLdJP0h0KN8XJPdLOS1dGYLfa6D8LTWrtAxhjEmpXRVFfTzPN57fCgoR4zRWntohuZFzhk03jrKEtFMCGFvhvZsQECR0HtXUI73feFMKUVHuZnZRzp7iR6IiOl/VL3q9dYB0VcsUV75W0hwzvF4nGaAT8C+Mlm1VsiaT5DnFQQ2lykTboEof3VgFnEawkXET3QXIaOiCBmF/F2EfmEO8QUj7b30BFJ34wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/last_page.png
// module id = G+OK
// module chunks = 8